import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kys-basic-info',
  templateUrl: './kys-basic-info.component.html',
  styleUrls: ['./kys-basic-info.component.scss']
})
export class KysBasicInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openModal(){
    const buttonModal = document.getElementById("openModalButton")
    console.log('buttonModal', buttonModal)
    buttonModal.click()
  }

}
